module.exports = __webpack_public_path__ + "img/white-square.e7671e84.svg";